import type { CSSProperties } from 'react'
import { DEFAULT_PARTICIPANT_VOLUME, useParticipantVolumes } from '../model/volume-store'

interface ParticipantVolumeProps {
  participantId: string
  /** Имя попадает в доступное имя слайдера: у соседних участников оно разное. */
  participantName: string
}

// Локальная громкость собеседника: отдельной строкой под именем, не иконкой в
// ряду модерации — «заглушить» глушит человека для всех и доступно только
// организатору, а это настройка своих наушников и есть у каждого.
export function ParticipantVolume({ participantId, participantName }: ParticipantVolumeProps) {
  const volume = useParticipantVolumes(
    (s) => s.volumes[participantId] ?? DEFAULT_PARTICIPANT_VOLUME,
  )
  const setVolume = useParticipantVolumes((s) => s.setVolume)
  const percent = Math.round(volume * 100)

  return (
    <label className="flex items-center gap-2" title="Громкость только у вас">
      <span className="label shrink-0">Громкость</span>
      <input
        type="range"
        min={0}
        max={100}
        step={5}
        value={percent}
        aria-label={`Громкость: ${participantName}`}
        onChange={(event) => setVolume(participantId, Number(event.target.value) / 100)}
        // --range-fill: заполненную часть тонкого трека WebKit рисует градиентом,
        // сам он её при appearance: none не красит.
        style={{ '--range-fill': percent / 100 } as CSSProperties}
        className="slider-thin min-w-0 flex-1"
      />
      <span className="w-9 shrink-0 text-right font-mono text-xs text-text-secondary">
        {percent}%
      </span>
    </label>
  )
}
